<template>
  <FormCard
    v-model="userMobileNumber"
    @formSubmit="$emit('formSubmit', $event)">
    <CardForm
      :resource="userMobileNumber"
      resource-name="user_mobile_number"
      :section-title="$t('common.mobile')">
      <vue-tel-input
        v-model="userMobileNumber.mobile_number"
        input-id="mobileInput"
        name="user_mobile_number[mobile_number]"
        :default-country="defaultCountryCode"
        :ignored-countries="['IL']"
        :valid-characters-only="true"
        :required="true"
        :disabled-fetching-country="true"
        wrapper-classes="ihjoz-tel-input"
        input-classes="ihjoz-tel-input-field"
        @input="validateNumber" />
      <input
        :value="selectedCountryCode"
        name="user_mobile_number[country_code]"
        type="hidden">
      <h4 class="form-card-body-information mb-0">
        {{ $t('user.smsVerification') }}
      </h4>
    </CardForm>
  </FormCard>
</template>
<script>
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import { VueTelInput } from "vue-tel-input";

export default {
  name: "NewUserMobileNumberForm",

  components: {
    FormCard,
    CardForm,
    VueTelInput
  },

  props: ["userMobileNumber"],

  data: function () {
    return {
      selectedCountryCode: 961
    };
  },

  computed: {
    defaultCountryCode () {
      return Dashboard.defaultCountryInfo.alpha2;
    }
  },

  mounted () {
    this.selectedCountryCode = this.$children[0].$children[0].$children[0].activeCountry.dialCode;
    this.$watch(() => this.$children[0].$children[0].$children[0].activeCountry.dialCode, (value) => { this.selectedCountryCode = value; });
  },

  methods: {
    validateNumber (formattedNumber, { number, valid, country }) {
      if (number.input && !valid) {
        document.getElementById("mobileInput").setCustomValidity("Please enter a valid mobile number.");
      } else {
        document.getElementById("mobileInput").setCustomValidity("");
      }
    }
  }
};
</script>
